// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyCXv5kLmLoAcn9p6tIHnBlgXbIwXDq_WEc',
    authDomain: 'maum-f2879.firebaseapp.com',
    projectId: 'maum-f2879',
    storageBucket: 'maum-f2879.appspot.com',
    messagingSenderId: '111454554120',
    appId: '1:111454554120:web:240a447519d7c9a0e5e9bd',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
